(() => {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const entries = new Map();
  const allowed = () => !reducedMotion.matches && !navigator.connection?.saveData;

  function load(entry) {
    const existing = entry.host.querySelector('video');
    const source = entry.host.querySelector('template')?.content.querySelector('video');
    const video = existing || source?.cloneNode(true);
    if (!video) return null;
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.controls = true;
    video.autoplay = false;
    video.preload = 'metadata';
    if (!existing) entry.host.appendChild(video);
    entry.host.setAttribute('loaded', 'true');
    entry.video = video;
    return video;
  }

  function update(entry) {
    if (!entry.visible || document.hidden || !allowed()) {
      if (entry.video && !entry.video.paused) {
        entry.managedPause = true;
        entry.video.pause();
      }
      return;
    }
    if (entry.blocked || entry.userPaused) return;
    const video = entry.video || load(entry);
    if (!video || !video.paused || entry.playingRequest) return;
    if (!entry.bound) {
      entry.bound = true;
      video.addEventListener('pause', () => {
        if (entry.managedPause) entry.managedPause = false;
        else if (entry.visible && !document.hidden) entry.userPaused = true;
      });
      video.addEventListener('play', () => { entry.userPaused = false; });
    }
    entry.playingRequest = true;
    Promise.resolve(video.play()).catch(() => {
      // Keep native controls available when the browser declines autoplay.
      entry.blocked = true;
    }).finally(() => { entry.playingRequest = false; });
  }

  const observer = new IntersectionObserver(changes => {
    for (const change of changes) {
      const entry = entries.get(change.target);
      entry.visible = change.isIntersecting && change.intersectionRatio >= 0.15;
      update(entry);
    }
  }, { threshold: [0, 0.15] });

  function scan() {
    document.querySelectorAll('media-gallery deferred-media').forEach(host => {
      if (entries.has(host) || !host.querySelector('template')?.content.querySelector('video')) return;
      host.parentElement.classList.add('pl08-native-gallery-video');
      const entry = { host, visible: false };
      entries.set(host, entry);
      observer.observe(host);
    });
  }
  document.addEventListener('visibilitychange', () => entries.forEach(update));
  reducedMotion.addEventListener('change', () => entries.forEach(update));
  document.addEventListener('shopify:section:load', scan);
  scan();
})();
